export default __webpack_public_path__ + "static/hero-illustration-c81b56e08a055f400058473041349728.svg";